import React, {useContext} from 'react'
import { Selected } from '../../../../context/context'
import LogoL from '../../../../assets/logo-l.png'
import LogoS from '../../../../assets/logo-s.png'
import {
    Content,
    Title,
    ButtonContainer,
    ImgContainer,
    Img,
} from './Elements'
import { 
    titleMotion,
    buttonContainerMotion,
    buttonMotion,
} from './Motion'

const LogoSize = ({ setSteps }) => {

    const [selected, setSelected] = useContext(Selected)

    const handleClick = (e) => {
        setSelected({...selected, size: e.target.value})
        setSteps(4)
    }

    return(
        <Content>
            <Title
            variants={titleMotion}
            initial='initial'
            animate='animate'
            exit='exit'
            >Elegí el tamaño del logo</Title>
            <ButtonContainer
            variants={buttonContainerMotion}
            initial='initial'
            animate='animate'
            exit='exit'
            >
                <ImgContainer
                value='small'
                variants={buttonMotion}
                style={{width: '5rem'}}
                onClick={handleClick}
                >
                    <Img src={LogoS}/>
                </ImgContainer>
                <ImgContainer
                value='big'
                variants={buttonMotion}
                style={{width: '8rem'}}
                onClick={handleClick}
                >
                    <Img src={LogoL}/>
                </ImgContainer>
            </ButtonContainer>
        </Content>
    )
}

export default LogoSize